import { PlanetModel, SectorModel } from "types";

import planetBishopImage from "assets/planet-bishop.svg";
import planetSenecaImage from "assets/planet-seneca.svg";

import { COLORS } from "utils/constants";
import BISHOP_SECTORS from "./bishop";
import SENECA_SECTORS from "./seneca";
import CONTRA_SECTORS from "./contra";

export const PLANETS: Record<string, PlanetModel> = {
  bishop: {
    slug: "bishop",
    name: "Bishop",
    description:
      "Bishop is the central hub planet of this corner of the universe. No matter your starship class or pilot profession, you'll find something useful here. There is the problem of that pesky Straylight clan who run the areas outside of the main city. Dope masks, though.",
    image: planetBishopImage,
    color: COLORS.LOCATION,
    mainArea: "bishopCity",
    linkSectors: ["bishopCity", "dashPort"],
    playlist: "bishop",
    isDefault: true,
  },
  seneca: {
    slug: "seneca",
    name: "Seneca",
    description:
      "Seneca is all about Antimatter energy. If you want the best in reactor cores to boost your pilot skills, Seneca has them. The planet itself consists of just a powerful antimatter core with no actual surface. The core powers all of the floating cities that were built around it, so residents of Seneca really love the core. Like a deep, slightly alarming love.",
    image: planetSenecaImage,
    color: COLORS.ENERGY,
    mainArea: "vale",
    linkSectors: ["vale", "core_horizon"],
    playlist: "seneca",
    isDefault: false,
  },
  contra: {
    slug: "contra",
    name: "Contra",
    description: "Seneca is the shield planet.",
    image: planetSenecaImage,
    color: COLORS.RESILIENCE,
    mainArea: "skylock",
    linkSectors: ["skylock"],
    playlist: "contra",
    isDefault: false,
    isDisabled: true,
  },
};

export const SECTORS: Record<string, SectorModel> = {
  ...BISHOP_SECTORS,
  ...SENECA_SECTORS,
  ...CONTRA_SECTORS,
};
